import { VueReCaptcha } from 'vue-recaptcha-v3'

export default async ({ Vue }) => {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA_SITE_KEY,
    loaderOptions: {
      autoHideBadge: true
    }
  })
}
